import { render } from "./PartnerSection.vue?vue&type=template&id=3a736e0a&scoped=true"
import script from "./PartnerSection.vue?vue&type=script&lang=js"
export * from "./PartnerSection.vue?vue&type=script&lang=js"

import "./PartnerSection.vue?vue&type=style&index=0&id=3a736e0a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a736e0a"]])

export default __exports__